namespace GeniuzPOS.AdvPromo {
    export interface Report_Adv01Row {
        ShopId?: string;
        ShopName?: string;
        ShopFullName?: string;
        PromoCampaign?: string;
        PmGroupId?: string;
        PmId?: string;
        PluCode?: string;
        PluShortDesc?: string;
        FullName?: string;
        SalesQty?: number;
        SalesAmtBeforePromo?: number;
        PromoDisc?: number;
        SalesAmtAfterPromo?: number;
    }

    export namespace Report_Adv01Row {
        export const idProperty = 'ShopId';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'AdvPromo.Report_Adv01';
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';

        export declare const enum Fields {
            ShopId = "ShopId",
            ShopName = "ShopName",
            ShopFullName = "ShopFullName",
            PromoCampaign = "PromoCampaign",
            PmGroupId = "PmGroupId",
            PmId = "PmId",
            PluCode = "PluCode",
            PluShortDesc = "PluShortDesc",
            FullName = "FullName",
            SalesQty = "SalesQty",
            SalesAmtBeforePromo = "SalesAmtBeforePromo",
            PromoDisc = "PromoDisc",
            SalesAmtAfterPromo = "SalesAmtAfterPromo"
        }
    }
}
